import { Component } from '@angular/core';

@Component({
	selector: 'vp-hero-item-sub-heading',
	template: '<ng-content />',
})
export class HeroItemSubHeading {}
